import { render } from "./ServicesPage.vue?vue&type=template&id=52501f2d&scoped=true"
const script = {}

import "./ServicesPage.vue?vue&type=style&index=0&id=52501f2d&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.10_vue@3.5.10_webpack@5.95.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52501f2d"]])

export default __exports__